module.exports = __webpack_public_path__ + "static/media/additional-guidance.d311a14d.svg";